/*******************************************************************************
 *** PrivacyPolicy ** 개인정보처리방침
 *******************************************************************************/
const PrivacyPolicy = () => {
    return (
        <div className="w100p h500">
            <div className="h100p mxh100p ofyA p10 bd1 bdcDDDDDD bdrd5 bgcWhite bsBdb">
                <p className="fm-c fs20 fc333333 mb10 lh20 pl5 taC">
                    전국우정노동조합 개인정보처리방침
                </p>

                <p className="fm-c fs15 fc333333 mt40 mb10 lh20 pl5">
                    (주)전국우정노동조합 (이하 "조합")은 「개인정보보호법」 등 관련 법령에 따라 이용자의 개인정보를
                    보호하고 관련 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리 방침을
                    수립·공개합니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제1조(개인정보 수집 목적 및 항목)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    조합은 회원가입, 시스템 운영 및 원활한 서비스 제공을 위해 최소한의 개인정보를 수집하고 있습니다.
                </p>

                <ul className="lsN pl20 mt5 mb10">
                    <li className="posR pl15 mb5 fm-c fs15 fc333333">
                        <span className="posA l0 t0 fc27AE60 fwB">•</span>
                        <span className="fm-c fwB fcC0392B dpInBlock mr5 pl5 bdl3 bdcE74C3C">수집 목적:</span>
                        회원 식별 및 가입 의사 확인, 시스템 권한 관리, 공지 및 연락사항 전달, 서비스 이용 기록 관리
                    </li>
                    <li className="posR pl15 mb5 fm-c fs15 fc333333">
                        <span className="posA l0 t0 fc27AE60 fwB">•</span>
                        <span className="fm-c fwB fcC0392B dpInBlock mr5 pl5 bdl3 bdcE74C3C">수집 항목 (필수):</span>
                        성명, 계정 ID, 비밀번호, 소속 본부/지부, 직책, 연락처(전화번호, 이메일)
                    </li>
                    <li className="posR pl15 mb5 fm-c fs15 fc333333">
                        <span className="posA l0 t0 fc27AE60 fwB">•</span>
                        <span className="fm-c fwB fcC0392B dpInBlock mr5 pl5 bdl3 bdcE74C3C">수집 항목 (선택):</span>
                        업무 관련 추가 정보
                    </li>
                </ul>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제2조(개인정보 보유 및 이용 기간)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    수집된 개인정보는 원칙적으로 회원 탈퇴 시 또는 정보의 수집 및 이용 목적이 달성된 후에는 지체
                    없이 파기됩니다. 다만, 관계 법령의 규정에 의하여 보존할 필요가 있는 경우 조합은 관계 법령에서
                    정한 기간 동안 회원 정보를 보관합니다.
                    <br />
                    * 보존 항목 및 기간:
                    <br />
                    * 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
                    <br />
                    * 기타 개별적으로 동의를 받은 경우: 동의를 받은 기간
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제3조(개인정보 파기 절차 및 방법)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    회원의 개인정보는 목적 달성 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 관계 법령 및 내부
                    방침에 따라 일정 기간 저장된 후 파기됩니다.
                    <br />
                    * 전자적 파일 형태: 기록을 재생할 수 없는 기술적 방법으로 영구 삭제
                    <br />
                    * 종이 문서: 분쇄기로 분쇄하거나 소각하여 파기
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제4조(동의를 거부할 권리 및 불이익)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    이용자는 개인정보 수집 및 이용에 대해 동의를 거부할 권리가 있습니다. 다만, 필수 항목에 대한
                    동의를 거부할 경우 회원가입 및 서비스 이용이 제한될 수 있습니다.
                </p>

                <p className="fm-c fs15 fwB mt30 fc3498DB ml10">
                    본 동의는 시스템의 정상적인 운영에 필수적인 사항입니다.
                </p>

            </div>
        </div>
    )
}

export default PrivacyPolicy;